import { useAppSelector } from '../hooks/useRedux';
import { isScheduleCallbackAllowed } from '../services/callback-whitelist';
import BookingOption, { BookingOptionPropType } from './BookingOption';
import CallYou from './CallYou';
import Confirmation from './Confirmation';

/**
 * This is more of a container component to determine whether the `<BookingOption/>` or `<CallYou/>` + `<Confirmation/>`
 * should be displayed in the next section, based on the user selection of `area` and `category`.
 *
 * @returns `<BookingOption/>` if it's allowed, else merely a `<CallYou/>` note + `<Confirmation/>`
 */
const WaysOfBooking = (props: BookingOptionPropType) => {
  const { area, category } = useAppSelector((state) => state.navigation);
  return isScheduleCallbackAllowed(area, category) ? (
    <BookingOption {...props} />
  ) : (
    <>
      <CallYou />
      <Confirmation />
    </>
  );
};

export default WaysOfBooking;
